import React from "react";

import { Calendar as CalendarIcon } from "react-feather";
import { Grid, TextField } from "@material-ui/core";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";

import { Salutation } from "@hubcapp/types";
import { SalutationButtons } from "@hubcapp/components";
import { createFakeEvent } from "@ds-developer/frontend";

import { LearnerDetailsFormFieldsProps } from "@hubcapp/components/Cards/LearnerDetails/components/Modals/LearnerDetailsModal/types";

import "../form.scss";

const LearnerDetailsFormFields: React.FC<LearnerDetailsFormFieldsProps> = ({
  errors,
  values,
  onFirstNameChange = () => {},
  onLastNameChange = () => {},
  onContactMobileChange = () => {},
  onContactEmailChange = () => {},
  onAddressLine1Change = () => {},
  onAddressLine2Change = () => {},
  onAddressTownChange = () => {},
  onAddressPostcodeChange = () => {},
  onDateOfBirthChange = () => {},
  onTitleChange = () => {},
}) => {
  const handleTitleChange = (title: Salutation) => {
    const event = createFakeEvent("title", title as Salutation);
    onTitleChange(event);
  };

  const handleDateOfBirthChange = (date: MaterialUiPickersDate) => {
    const event = createFakeEvent("dateOfBirth", date as Date);
    onDateOfBirthChange(event);
  };

  return (
    <Grid container spacing={3} className="form">
      <Grid item xs={9}>
        <SalutationButtons value={values.title} onChange={handleTitleChange} />
      </Grid>

      <Grid item xs={6}>
        <TextField
          id="learner-details-form-first-name"
          fullWidth
          label="First name"
          variant="outlined"
          name="firstName"
          onChange={onFirstNameChange}
          value={values?.firstName}
          error={Boolean(errors?.firstName)}
          helperText={errors?.firstName?.message}
          data-test="learner-details-form-first-name"
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          id="learner-details-form-last-name"
          data-test="learner-details-form-last-name"
          fullWidth
          label="Last name"
          variant="outlined"
          name="lastName"
          onChange={onLastNameChange}
          value={values?.lastName}
          helperText={errors?.lastName?.message}
          error={Boolean(errors?.lastName)}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          id="learner-details-form-mobile-phone"
          data-test="learner-details-form-mobile-phone"
          fullWidth
          label="Phone"
          variant="outlined"
          type="number"
          className="phone-input"
          name="contactMobile"
          onChange={onContactMobileChange}
          value={values?.contactMobile}
          helperText={errors?.contactMobile?.message}
          error={Boolean(errors?.contactMobile)}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          id="learner-details-form-email"
          data-test="learner-details-form-email"
          fullWidth
          label="Email"
          variant="outlined"
          name="contactEmail"
          onChange={onContactEmailChange}
          value={values?.contactEmail}
          helperText={errors?.contactEmail?.message.message}
          error={Boolean(errors?.contactEmail)}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          id="learner-details-form-address-line-1"
          data-test="learner-details-form-address-line-1"
          fullWidth
          label="Address 1"
          variant="outlined"
          name="addressLine1"
          onChange={onAddressLine1Change}
          value={values?.addressLine1}
          helperText={errors?.addressLine1?.message}
          error={Boolean(errors?.addressLine1)}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          id="learner-details-form-address-line-2"
          data-test="learner-details-form-address-line-2"
          fullWidth
          label="Address 2"
          variant="outlined"
          name="addressLine2"
          onChange={onAddressLine2Change}
          value={values?.addressLine2}
          helperText={errors?.addressLine2?.message}
          error={Boolean(errors?.addressLine2)}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          id="learner-details-form-address-town"
          data-test="learner-details-form-address-town"
          fullWidth
          label="Town/city"
          variant="outlined"
          name="addressTown"
          onChange={onAddressTownChange}
          value={values?.addressTown}
          helperText={errors?.addressTown?.message}
          error={Boolean(errors?.addressTown)}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          id="learner-details-form-address-postcode"
          data-test="learner-details-form-address-postcode"
          fullWidth
          label="Postcode"
          variant="outlined"
          name="addressPostcode"
          onChange={onAddressPostcodeChange}
          value={values?.addressPostcode}
          helperText={errors?.addressPostcode?.message}
          error={Boolean(errors?.addressPostcode)}
        />
      </Grid>

      <Grid item xs={12}>
        <KeyboardDatePicker
          id="learner-details-form-date-of-birth"
          data-test="learner-details-form-date-of-birth"
          fullWidth
          label="Date of birth"
          minDateMessage=""
          maxDateMessage=""
          onChange={handleDateOfBirthChange}
          value={values?.dateOfBirth}
          variant="inline"
          format="dd/MM/yyyy"
          inputVariant="outlined"
          error={Boolean(errors?.dateOfBirth)}
          disableToolbar
          keyboardIcon={<CalendarIcon />}
        />
      </Grid>
    </Grid>
  );
};

export default LearnerDetailsFormFields;
